import { render, staticRenderFns } from "./DbWidgetContainer.vue?vue&type=template&id=67ee4b0f&"
import script from "./DbWidgetContainer.vue?vue&type=script&lang=js&"
export * from "./DbWidgetContainer.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports